import Axios from "../../../axios.js";
import {advertisementApiConstants} from "../../../constants/ApiConstant";

// Advertisement admin CRUD calls.
//
// - search: POST with no body → { advertisementList, size } (newest first,
//   soft-deleted rows excluded).
// - save:   upsert. Include `id` to edit, omit it to create. Returns 201 with
//   an empty body — callers just re-run search() to refresh the list.
// - delete: soft delete. Requires `id`; `remarks` is optional.

export async function searchAdvertisements() {
    return Axios.post(advertisementApiConstants.SEARCH_ADVERTISEMENT, {});
}

export async function saveAdvertisement(params) {
    return Axios.post(advertisementApiConstants.SAVE_ADVERTISEMENT, params);
}

export async function deleteAdvertisement(params) {
    return Axios.post(advertisementApiConstants.DELETE_ADVERTISEMENT, params);
}
